import script from "./ReviewQueueView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewQueueView.vue?vue&type=script&setup=true&lang=js"

import "./ReviewQueueView.vue?vue&type=style&index=0&id=fef79f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fef79f74"]])

export default __exports__